// removed by extract-text-webpack-plugin
module.exports = {"error":"style__error___29svF","button":"style__button___oZK_E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/error-handler/style.css
// module id = 493
// module chunks = 0